module.exports = __webpack_public_path__ + "static/media/declaration-form-step4.e39e5329.svg";